/**
 * One line under every rollup-backed number: how current it is. The rollups
 * lag the ingest by the recompute queue, and a screen must say so rather than
 * present a number as live (release 2.1 item 18).
 */

import { Clock } from 'lucide-react';

import type { Freshness } from '@/lib/fleet-api';
import { cn } from '@/lib/cn';

import { freshnessText } from './fleet-format';

export function FreshnessNote({ freshness, className }: { freshness: Freshness | null | undefined; className?: string }) {
  if (!freshness) return null;
  const behind = freshness.visible && freshness.pendingDevices > 0;
  return (
    <div
      className={cn(
        'flex items-center gap-1.5 text-[11px]',
        behind ? 'text-warning' : 'text-muted-foreground',
        className,
      )}
    >
      <Clock className="h-3 w-3 shrink-0" />
      <span>{freshnessText(freshness)}</span>
    </div>
  );
}
